import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StylePaginationBarWrapper: any = styled.div`
  width: 100%;
  padding-bottom: 4px;
  order: 2;
  @media (min-width: ${Breakpoints.b960}px) {
    order: 1;
  }
`;

export const StyledFiveStarsCarouselContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  .slick-pagination-bar {
    order: 2;
    @media (min-width: ${Breakpoints.b960}px) {
      order: 1;
    }
  }
  .slick-carousel {
    order: 3;
    width: 100%;
    @media (min-width: ${Breakpoints.b960}px) {
      padding-right: 40px;
      width: 68%;
      order: 2;
    }
  }
  .slick-slide {
    & > :first-child {
      width: 100%;
    }
  }
`;
interface StyledCarouselWrapperProps {
  singleelement?: boolean;
}

export const StyledCarouselWrapper: any = styled.div<
  StyledCarouselWrapperProps
>`
  ${(props: StyledCarouselWrapperProps) =>
    !props.singleelement && 'margin-right: -355px;'}
  @media (min-width: ${Breakpoints.b560}px) {
    margin-right: -330px;
  }
`;

export const StyledContainer: any = styled.div<StyledCarouselWrapperProps>`
  width: 100%;
  height: 100%;
  padding-right: ${(props: StyledCarouselWrapperProps) =>
    props.singleelement ? 0 : '10px'};
  @media (min-width: ${Breakpoints.b560}px) {
    padding-right: 40px;
  }
`;

export const StyledModelCardWrapper: any = styled.div`
  order: 1;
  width: 100%;
  @media (min-width: ${Breakpoints.b960}px) {
    padding-right: 40px;
    width: 32%;
    order: 2;
  }
`;

export const StyledCarouselContainer: any = styled.div`
  order: 3;
  width: 100%;
  @media (min-width: ${Breakpoints.b960}px) {
    width: 68%;
  }
`;
